import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import { CANCELABLE_PERIOD } from '@/constants/renonciation';

import styles from './styles.module.css';

interface CancelContractButtonProps {
  isCancelable?: boolean | null;
  cancelablePeriod?: number | null;
  onClick: () => void;
}

const CancelContractButton = ({ isCancelable, cancelablePeriod, onClick }: CancelContractButtonProps) => {
  const { t } = useTranslation();

  if (!isCancelable) return null;

  const label =
    cancelablePeriod === CANCELABLE_PERIOD.RETRACTATION ? t('common.retractableCTA') : t('common.cancelableCTA');

  return (
    <MtxButton variant="tertiary" size="medium" className={styles.cancelContractButton} onClick={onClick}>
      <div>{label}</div>
    </MtxButton>
  );
};

export default CancelContractButton;
